import { render } from "./project-modal.vue?vue&type=template&id=c15666a2"
import script from "./project-modal.vue?vue&type=script&lang=js"
export * from "./project-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__